export default {
    meta: {
        title: '新增跟进',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
